import moment from 'moment';

import { Establishment } from '@models/account/establishment.model';
import { LegalEntity } from '@models/account/legal-entity.model';

import { ApiAdapter } from './adapter';

export class EstablishmentAdapter extends ApiAdapter<Establishment> {
  get(json): Establishment {
    if (!json) {
      return null;
    }
    const establishmentJson = json['establishment'] ? json['establishment'] : json;
    return new Establishment({
      id: json['link_id'],
      code: establishmentJson['code'],
      legalEntity: new LegalEntity({
        code: establishmentJson['legal_entity_code'],
      }),
      repetitionIndex: establishmentJson['indrep'],
      postalCode: establishmentJson['codpos'],
      address: establishmentJson['address'],
      roadType: establishmentJson['typvoie'],
      roadNumber: establishmentJson['numvoie'],
      roadName: establishmentJson['libvoie'],
      cedex: establishmentJson['cedex'],
      libcom: establishmentJson['libcom'],
      vat: establishmentJson['tva_intra'],
      siege: establishmentJson['siege'],
      commercialName: establishmentJson['enseigne'],
      activityCode: establishmentJson['apet700'],
      activityLabel: establishmentJson['libapet'],

      validityStartDate: json['validity_start_date'] ? moment.tz(json['validity_start_date'], moment.tz.guess()) : undefined,
      validityEndDate: json['validity_end_date'] ? moment.tz(json['validity_end_date'], moment.tz.guess()) : undefined,
    });
  }
}
